import { render, staticRenderFns } from "./AuthPending.vue?vue&type=template&id=16a2a147"
import script from "./AuthPending.vue?vue&type=script&lang=ts"
export * from "./AuthPending.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports